import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { trpc } from "@/lib/trpc";
import { useEffect, useState } from "react";
import { toast } from "sonner";

export const KEYWORD_CATEGORY_OPTIONS = [
  "鴻鼎菓子｜伴手禮需求",
  "鴻鼎菓子｜節慶送禮",
  "鴻鼎菓子｜企業採購",
  "鴻鼎菓子｜產品品項",
  "鴻鼎菓子｜品牌查詢",
  "瞇瞇眼｜蛋糕甜點需求",
  "瞇瞇眼｜彌月送禮",
  "瞇瞇眼｜團購宅配",
  "瞇瞇眼｜產品品項",
  "瞇瞇眼｜品牌查詢",
  "未分類",
] as const;

export type KeywordCategoryOption = (typeof KEYWORD_CATEGORY_OPTIONS)[number];
export type KeywordBrandKey = "IDODO" | "MIMIAN";

const IDODO_CATEGORY_ALIASES: Record<string, KeywordCategoryOption> = {
  伴手禮: "鴻鼎菓子｜伴手禮需求",
  台中伴手禮: "鴻鼎菓子｜伴手禮需求",
  禮盒: "鴻鼎菓子｜伴手禮需求",
  台中禮盒: "鴻鼎菓子｜伴手禮需求",
  企業禮盒: "鴻鼎菓子｜企業採購",
  企業採購: "鴻鼎菓子｜企業採購",
  過年禮盒: "鴻鼎菓子｜節慶送禮",
  年節禮盒: "鴻鼎菓子｜節慶送禮",
  中秋禮盒: "鴻鼎菓子｜節慶送禮",
  彌月蛋糕: "鴻鼎菓子｜產品品項",
  波士頓派: "鴻鼎菓子｜產品品項",
  曲奇餅: "鴻鼎菓子｜產品品項",
  曲奇餅乾: "鴻鼎菓子｜產品品項",
  檸檬酥: "鴻鼎菓子｜產品品項",
  堅果塔: "鴻鼎菓子｜產品品項",
  鳳凰酥: "鴻鼎菓子｜產品品項",
  團購甜點: "鴻鼎菓子｜產品品項",
  "鴻鼎菓子｜台中伴手禮": "鴻鼎菓子｜伴手禮需求",
  "鴻鼎菓子｜台中禮盒": "鴻鼎菓子｜伴手禮需求",
  "鴻鼎菓子｜泛禮盒": "鴻鼎菓子｜伴手禮需求",
  "鴻鼎菓子｜年節禮盒": "鴻鼎菓子｜節慶送禮",
  "鴻鼎菓子｜中秋禮盒": "鴻鼎菓子｜節慶送禮",
  "鴻鼎菓子｜彌月蛋糕": "鴻鼎菓子｜產品品項",
  "鴻鼎菓子｜波士頓派": "鴻鼎菓子｜產品品項",
  "鴻鼎菓子｜曲奇餅乾": "鴻鼎菓子｜產品品項",
  "鴻鼎菓子｜檸檬酥": "鴻鼎菓子｜產品品項",
  "鴻鼎菓子｜堅果塔": "鴻鼎菓子｜產品品項",
  "鴻鼎菓子｜鳳凰酥": "鴻鼎菓子｜產品品項",
  "鴻鼎菓子｜團購甜點": "鴻鼎菓子｜產品品項",
  鴻鼎菓子: "鴻鼎菓子｜品牌查詢",
  未分類: "未分類",
};

const MIMIAN_CATEGORY_ALIASES: Record<string, KeywordCategoryOption> = {
  波士頓派: "瞇瞇眼｜產品品項",
  全生乳波士頓派: "瞇瞇眼｜產品品項",
  蛋糕: "瞇瞇眼｜蛋糕甜點需求",
  生日蛋糕: "瞇瞇眼｜蛋糕甜點需求",
  甜點: "瞇瞇眼｜蛋糕甜點需求",
  團購甜點: "瞇瞇眼｜團購宅配",
  團購: "瞇瞇眼｜團購宅配",
  宅配: "瞇瞇眼｜團購宅配",
  冷凍宅配: "瞇瞇眼｜團購宅配",
  彌月: "瞇瞇眼｜彌月送禮",
  彌月蛋糕: "瞇瞇眼｜彌月送禮",
  彌月禮盒: "瞇瞇眼｜彌月送禮",
  瞇瞇眼: "瞇瞇眼｜品牌查詢",
  咪咪眼: "瞇瞇眼｜品牌查詢",
  MIMIAN: "瞇瞇眼｜品牌查詢",
  "瞇瞇眼｜波士頓派": "瞇瞇眼｜產品品項",
  "瞇瞇眼｜生日蛋糕": "瞇瞇眼｜蛋糕甜點需求",
  "瞇瞇眼｜彌月": "瞇瞇眼｜彌月送禮",
  "瞇瞇眼｜團購": "瞇瞇眼｜團購宅配",
  "瞇瞇眼｜宅配": "瞇瞇眼｜團購宅配",
  未分類: "未分類",
};

export function normalizeKeywordCategory(category?: string | null, brand?: KeywordBrandKey): KeywordCategoryOption {
  const value = (category || "未分類").trim();
  if (KEYWORD_CATEGORY_OPTIONS.includes(value as KeywordCategoryOption)) {
    return value as KeywordCategoryOption;
  }
  if (brand === "MIMIAN") return MIMIAN_CATEGORY_ALIASES[value] || IDODO_CATEGORY_ALIASES[value] || "未分類";
  if (brand === "IDODO") return IDODO_CATEGORY_ALIASES[value] || MIMIAN_CATEGORY_ALIASES[value] || "未分類";
  return IDODO_CATEGORY_ALIASES[value] || MIMIAN_CATEGORY_ALIASES[value] || "未分類";
}

interface KeywordCreateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  defaultKeyword?: string;
  defaultCategory?: string | null;
  defaultBrand?: KeywordBrandKey;
  onCreated?: (created: { keyword: string; category: string }) => void;
}

export default function KeywordCreateDialog({
  open,
  onOpenChange,
  defaultKeyword = "",
  defaultCategory = "未分類",
  defaultBrand,
  onCreated,
}: KeywordCreateDialogProps) {
  const [keyword, setKeyword] = useState(defaultKeyword);
  const [category, setCategory] = useState(normalizeKeywordCategory(defaultCategory, defaultBrand));
  const utils = trpc.useUtils();

  useEffect(() => {
    if (!open) return;
    setKeyword(defaultKeyword);
    setCategory(normalizeKeywordCategory(defaultCategory, defaultBrand));
  }, [defaultBrand, defaultCategory, defaultKeyword, open]);

  const createMutation = trpc.keywords.create.useMutation({
    onSuccess: () => {
      utils.keywords.getAll.invalidate();
      utils.keywords.getCategories.invalidate();
      toast.success("關鍵字已加入列表");
      onCreated?.({
        keyword: keyword.trim(),
        category,
      });
      onOpenChange(false);
    },
    onError: (error) => {
      toast.error(`加入失敗：${error.message}`);
    },
  });

  const handleCreate = () => {
    if (!keyword.trim()) {
      toast.error("請輸入關鍵字");
      return;
    }

    createMutation.mutate({
      keyword: keyword.trim(),
      category,
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>新增關鍵字</DialogTitle>
          <DialogDescription>
            新增要追蹤的關鍵字，系統將自動抓取趨勢數據
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="create-keyword">關鍵字 *</Label>
            <Input
              id="create-keyword"
              placeholder="例如：全生乳波士頓派"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="create-category">分類</Label>
            <Select value={category} onValueChange={(value) => setCategory(normalizeKeywordCategory(value, defaultBrand))}>
              <SelectTrigger id="create-category">
                <SelectValue placeholder="選擇分類" />
              </SelectTrigger>
              <SelectContent>
                {KEYWORD_CATEGORY_OPTIONS.map((item) => (
                  <SelectItem key={item} value={item}>
                    {item}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            取消
          </Button>
          <Button onClick={handleCreate} disabled={createMutation.isPending}>
            {createMutation.isPending ? "新增中..." : "新增"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
